import { render, staticRenderFns } from "./StaffDailyIncome.vue?vue&type=template&id=d63e9af8"
import script from "./StaffDailyIncome.vue?vue&type=script&lang=js"
export * from "./StaffDailyIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports